import React, { Component, ReactNode, WheelEvent } from 'react';
import CreateFolderItem from '../components/folder/CreateFolderItem';
import { query, repository, subscribe } from '@trlogic/client-js';
import ComponentName from '../constant/ComponentName';
import ComponentCategoryUtil from '../util/ComponenyCategoryUtil';
import { ComponentCategory, EnrichedComponentCategory } from '../domain/category/CategoryOperationDomains';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import FolderItem from '../components/folder/FolderItem';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { RootState, store } from '../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import {
  changeActivePageIndex,
  changeCurrentCategory,
  changeCurrentComponent,
  changeEnrichedCategories,
  changePagePath,
  clearPage,
} from '../redux/actions/PageActions';
import FolderUtil from '../util/FolderUtil';
import { changeCategory } from '../redux/actions/CategoryActions';
import { initialPagePath, PagePath, PageState } from '../redux/reducers/PageReducer';
import FolderView from '../components/folder/view/FolderView';
import FolderService from '../service/FolderService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import Modal from 'components/folder/view/Modal';
import RoleHelper from '../RoleHelper';
import Icon from '../icons/Icon';
import { setSelectedItems } from '../redux/actions/ComponentActions';
import $ from 'jquery';
import { getComponentIcon } from '../util/GetComponentIcon';
import QueryBuilder = query.QueryBuilder;
import LanguageUtil from '../util/LanguageUtil';

class FolderContainer extends Component<Props, State> {
  public state: State = new State();
  private categorySubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;
  private folderService: FolderService = ServiceContainer.getInstance().get(ServiceNames.FOLDER);
  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  public render(): ReactNode {
    const {
      currentCategory,
      component,
      router: { navigate },
      page,
      views,
      selectedFolders,
    } = this.props;
    return (
      <div
        className={
          'flex flex-col justify-center rounded items-center min-h-[154px] h-[154px] box-border 2xl:min-h-[180px] 2xl:h-[180px] px-4 overflow-y-hidden shrink-0 container   bg-white font-formica z-0'
        }
      >
        <div className={'text-xs text-f-black-3  self-start select-non px-3'}>
          {LanguageUtil.get({ id: 'common.label.folders', defaultMessage: 'Folders' })}
        </div>
        <div className={'h-full w-full flex items-center self-start justify-start'}>
          <div className={'flex justify-center items-center px-2 border-r-2 border-[#f6f6f9] '}>
            <div className={'flex-1 flex-shrink-0'}>
              <CreateFolderItem component={component} />
            </div>
          </div>
          {
            <div onWheel={this.handleWheel} id='slide' className='flex w-full gap-x-2 px-2 overflow-x-scroll overflow-y-hidden custom-scroll'>
              {views &&
                views.length > 0 &&
                currentCategory?.categories.map((c: EnrichedComponentCategory, i: number) => (
                  <FolderItem
                    key={i}
                    view={views.find((v: FolderView) => v.getModel().value?.payload.id == c.id)}
                    onClick={() => {
                      this.switchToCategory(c);
                      navigate(`/${component.toLowerCase()}/folder/${c.id}`);
                    }}
                    selectedFolders={selectedFolders}
                    setSelectedFolders={this.setSelectedFolders}
                    category={c}
                    page={page}
                    component={component}
                  />
                ))}
            </div>
          }
        </div>
      </div>
    );
  }

  public componentDidMount(): void {
    const { component } = this.props;
    if (component) {
      this.folderService.fixComponent(component);
    }
    this.initializeListeners();
    this.startTracker();
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const { currentCategory, setSelectedFolders, setSelectedItems, changeCurrentCategory, enrichedCategories, pagePath, changeActivePageIndex } = this.props;
    if (prevProps.currentCategory != currentCategory) {
      setSelectedFolders([]);
      setSelectedItems([]);
    }
    if (prevProps.router.params.folderId != this.props.router.params.folderId) {
      setTimeout(() => {
        const currentFolder = this.props.router.params.folderId;
        if (currentCategory?.id != currentFolder) {
          if (currentFolder == 'Main' || currentFolder == undefined) {
            changeCurrentCategory(enrichedCategories['Main']);
            changeActivePageIndex(0);
          } else {
            const folder = Object.values(enrichedCategories).find((c) => c.id == currentFolder);
            if (folder != undefined) {
              const pagePathIndex = pagePath.findIndex((p) => p.payload.id == currentFolder);
              if (pagePathIndex != -1) {
                changeActivePageIndex(pagePathIndex);
              }
              changeCurrentCategory(folder);
            }
          }
        }
      }, 0);
    }
  }

  public async componentWillUnmount() {
    const { clearPage } = this.props;
    clearPage();
    this.terminateListeners();
    await this.stopTracker();
  }

  private startTracker = () => {
    const { component } = this.props;
    const collectionName = ComponentCategoryUtil.getCollectionName(component);
    const query = QueryBuilder.select().from(collectionName).build();
    this.categorySubscription = subscribe.Formica.subscribe(collectionName, query);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.categorySubscription]);
  };

  private tracker = async () => {
    if (this.categorySubscription?.ready()) {
      const {
        component,
        router: { location, params },
      } = this.props;
      const collectionName = ComponentCategoryUtil.getCollectionName(component);
      const categoryQuery: query.Query = query.QueryBuilder.select().from(collectionName).build();
      const categories: ComponentCategory[] = await this.repository.findMany(categoryQuery);
      this.setState({ categories, loading: false }, () => {
        FolderService.calculate('SWITCH_TO_CATEGORY', component, location.pathname, store.getState().page, params.folderId ?? 'Main', categories);
      });
    }
  };

  private enrichCategory = (id: string) => {
    const { categories } = this.state;
    const { changeCurrentCategory, changeEnrichedCategories, currentCategory, activePageIndex, pagePath } = this.props;
    const categoryMap: Record<string, EnrichedComponentCategory> = {};
    const enrichedMainCategory = ComponentCategoryUtil.enrichMainCategory(id, categories, [], categoryMap);
    changeEnrichedCategories(categoryMap);
    if (enrichedMainCategory) {
      if (currentCategory == undefined) {
        this.switchToCategory(enrichedMainCategory);
      } else {
        const activePath: PagePath = pagePath[activePageIndex];
        if (activePath && activePath.type == 'category') {
          changeCurrentCategory(categoryMap[activePath.categoryPath]);
        } else if (activePageIndex == 0) {
          this.switchToCategory(enrichedMainCategory);
        }
      }
      this.setState({ enrichedMainCategory: enrichedMainCategory });
    }
  };

  private stopTracker = async () => {
    await this.categorySubscription?.stop();
    this.computation?.stop();
  };

  private switchToCategory = (enrichCategory: EnrichedComponentCategory) => {
    const { changePagePath, changeCategory, component, changeActivePageIndex, changeCurrentCategory, enrichedCategories } = this.props;

    let payload: EnrichedComponentCategory;
    if (enrichCategory && enrichCategory.id == 'Main') {
      payload = enrichCategory;
    } else {
      payload = enrichedCategories['Main'];
    }
    const pageInfo = initialPagePath[component]?.title ?? component;
    const pages: PagePath[] = [
      {
        title: pageInfo,
        categoryPath: 'Main',
        path: `/${component.toLowerCase()}`,
        icon: <Icon size={16} icon={getComponentIcon(component)} />,
        type: 'category',
        payload: payload,
      },
    ];

    FolderUtil.calculateCurrentCategoryPath(enrichCategory, pages, enrichedCategories, component.toLowerCase());
    changePagePath(pages);
    changeActivePageIndex(enrichCategory.path.length - 1);
    changeCategory({ component: component, activePage: enrichCategory.id });
    changeCurrentCategory(enrichCategory);
  };

  private handleWheel = (event: WheelEvent) => {
    const container: HTMLElement = event.currentTarget as HTMLElement;
    const { deltaY, deltaX } = event;
    if (!container) return;
    Math.abs(deltaX) > Math.abs(deltaY) ? (container.scrollLeft += deltaX * 0.2) : (container.scrollLeft += deltaY * 0.2);
  };

  private wheelToRight = () => {
    const folderContainer = document.getElementById('slide');
    if (folderContainer) {
      folderContainer.scrollLeft += 200;
    }
  };

  private wheelToLeft = () => {
    const folderContainer = document.getElementById('slide');
    if (folderContainer) {
      folderContainer.scrollLeft -= 200;
    }
  };

  private initializeListeners = () => {
    $(document).on('folder:clear-selected-folders', this.clearSelectedFolders);
  };

  private terminateListeners = () => {
    $(document).off('folder:clear-selected-folders', this.clearSelectedFolders);
  };

  private clearSelectedFolders = () => {
    const { setSelectedFolders, component } = this.props;
    if (!RoleHelper.canEdit(ComponentCategoryUtil.getRoleNamesByComponent(component))) return;
    setSelectedFolders([]);
  };

  private setSelectedFolders = (folders: Modal[]) => {
    const { setSelectedFolders, component } = this.props;
    if (!RoleHelper.canEdit(ComponentCategoryUtil.getRoleNamesByComponent(component))) return;
    setSelectedFolders(folders);
  };
}

class State {
  loading: boolean = true;
  categories: ComponentCategory[] = [];
  enrichedMainCategory: EnrichedComponentCategory | undefined;
}

interface Props extends ReduxProps, FormicaProps {
  component: ComponentName;
  path: string;
  views: FolderView[];
  selectedFolders: Modal[];
  setSelectedFolders: (folders: Modal[]) => void;
}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  page: state.page as PageState,
  pagePath: state.page.pagePath as PagePath[],
  categoryPages: state.category.pages,
  activePageIndex: state.page.activePageIndex,
  currentCategory: state.page.currentCategory,
  enrichedCategories: state.page.enrichedCategories as Record<string, EnrichedComponentCategory>,
});
const mapDispatchToProps = {
  changePagePath,
  changeCategory,
  changeActivePageIndex,
  changeCurrentCategory,
  changeEnrichedCategories,
  clearPage,
  changeCurrentComponent,
  setSelectedItems,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(FolderContainer));
